import { render, staticRenderFns } from "./BossTable.vue?vue&type=template&id=df150e64&scoped=true"
import script from "./BossTable.vue?vue&type=script&lang=js"
export * from "./BossTable.vue?vue&type=script&lang=js"
import style0 from "./BossTable.vue?vue&type=style&index=0&id=df150e64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df150e64",
  null
  
)

export default component.exports